var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#3F0099"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 21,
    width: 23,
    height: 33,
    fill: "url(#paint0_linear_220_13293)",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9547 32.6504V35.977H35.087L33.145 34.3137L35.087 32.6504H45.9547Z",
    fill: "#3F0099"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9547 38.7207V42.0472H35.087L33.145 40.384L35.087 38.7207H45.9547Z",
    fill: "#3F0099"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9547 44.792V48.1185H35.087L33.145 46.4552L35.087 44.792H45.9547Z",
    fill: "#3F0099"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6329 20.1191H27.3666C26.2795 20.1191 25.3955 21.0034 25.3955 22.0902V52.9104C25.3955 53.9973 26.2795 54.8815 27.3666 54.8815H47.6329C48.72 54.8815 49.604 53.9973 49.604 52.9104V22.0902C49.604 21.0034 48.72 20.1191 47.6329 20.1191ZM48.5289 52.9104C48.5289 53.4044 48.1271 53.8064 47.6329 53.8064H27.3666C26.8724 53.8064 26.4707 53.4044 26.4707 52.9104V22.0902C26.4707 21.5962 26.8724 21.1943 27.3666 21.1943H47.6329C48.1271 21.1943 48.5289 21.5962 48.5289 22.0902V52.9104Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4598 23.7129H30.1216C29.8248 23.7129 29.584 23.9535 29.584 24.2505V28.618C29.584 28.915 29.8247 29.1556 30.1216 29.1556C30.4183 29.1556 30.6591 28.915 30.6591 28.618V26.9719H31.4599C32.3583 26.9719 33.0894 26.241 33.0894 25.3424C33.0894 24.4439 32.3582 23.7129 31.4598 23.7129ZM31.4598 25.8967H30.6591V24.788H31.4598C31.7653 24.788 32.0142 25.0367 32.0142 25.3424C32.0142 25.6481 31.7654 25.8967 31.4598 25.8967Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5009 29.1556C37.7976 29.1556 38.0385 28.915 38.0385 28.618V27.3089H39.3936V28.618C39.3936 28.915 39.6343 29.1556 39.9311 29.1556C40.2279 29.1556 40.4687 28.915 40.4687 28.618V25.4658C40.4687 24.4993 39.6823 23.7129 38.716 23.7129C37.7498 23.7129 36.9634 24.4993 36.9634 25.4658V28.618C36.9634 28.915 37.2041 29.1556 37.5009 29.1556ZM38.716 24.788C39.0898 24.788 39.3936 25.092 39.3936 25.4658V26.2338H38.0385V25.4658C38.0385 25.092 38.3423 24.788 38.716 24.788Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.878 23.7129C44.5813 23.7129 44.3404 23.9535 44.3404 24.2505V26.8986L42.2927 23.9443C42.159 23.7511 41.9144 23.6673 41.6908 23.7374C41.4664 23.8076 41.3135 24.0155 41.3135 24.2505V28.618C41.3135 28.915 41.5542 29.1556 41.8511 29.1556C42.1479 29.1556 42.3886 28.915 42.3886 28.618V25.9698L44.4363 28.9241C44.5726 29.121 44.8192 29.1999 45.0383 29.131C45.2627 29.0608 45.4156 28.8529 45.4156 28.6179V24.2504C45.4156 23.9534 45.1748 23.7129 44.878 23.7129Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6358 28.618C36.6358 28.3211 36.395 28.0804 36.0982 28.0804H34.4921V24.2505C34.4921 23.9535 34.2514 23.7129 33.9546 23.7129C33.6578 23.7129 33.417 23.9535 33.417 24.2505V28.618C33.417 28.915 33.6578 29.1556 33.9546 29.1556H36.0982C36.3949 29.1556 36.6358 28.915 36.6358 28.618Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0037 33.0618L29.6413 34.4241L29.425 34.2078C29.215 33.9978 28.8748 33.998 28.6648 34.2076C28.4548 34.4176 28.4548 34.7579 28.6648 34.9679L29.2612 35.5644C29.472 35.7752 29.8123 35.7734 30.0213 35.5644L31.7639 33.8218C31.9739 33.612 31.9739 33.2715 31.7639 33.0617C31.5539 32.8518 31.2137 32.8518 31.0037 33.0618Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8335 33.7764H35.7368C35.44 33.7764 35.1992 34.017 35.1992 34.3139C35.1992 34.6109 35.44 34.8515 35.7368 34.8515H40.8335C41.1302 34.8515 41.371 34.6109 41.371 34.3139C41.371 34.017 41.1302 33.7764 40.8335 33.7764Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0037 39.1331L29.6413 40.4954L29.425 40.2791C29.215 40.0691 28.8748 40.0693 28.6648 40.2789C28.4548 40.4889 28.4548 40.8292 28.6648 41.0392L29.2612 41.6357C29.472 41.8465 29.8123 41.8447 30.0213 41.6357L31.7639 39.8932C31.9739 39.6834 31.9739 39.3428 31.7639 39.133C31.5539 38.9231 31.2137 38.9231 31.0037 39.1331Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8335 39.8467H35.7368C35.44 39.8467 35.1992 40.0873 35.1992 40.3843C35.1992 40.6812 35.44 40.9218 35.7368 40.9218H40.8335C41.1302 40.9218 41.371 40.6812 41.371 40.3843C41.371 40.0873 41.1302 39.8467 40.8335 39.8467Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0037 45.2034L29.6413 46.5657L29.425 46.3494C29.215 46.1394 28.8748 46.1396 28.6648 46.3492C28.4548 46.5592 28.4548 46.8995 28.6648 47.1095L29.2612 47.706C29.472 47.9168 29.8123 47.915 30.0213 47.706L31.7639 45.9634C31.9739 45.7536 31.9739 45.4131 31.7639 45.2033C31.5539 44.9934 31.2137 44.9934 31.0037 45.2034Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8335 45.917H35.7368C35.44 45.917 35.1992 46.1576 35.1992 46.4546C35.1992 46.7515 35.44 46.9921 35.7368 46.9921H40.8335C41.1302 46.9921 41.371 46.7515 41.371 46.4546C41.371 46.1576 41.1302 45.917 40.8335 45.917Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_13293",
    x1: 39.4167,
    y1: 21,
    x2: 39.4167,
    y2: 58.7143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxicon2);
export default __webpack_public_path__ + "static/media/boxicon2.1371d083f291a18862ea529b67ff45fb.svg";
export { ForwardRef as ReactComponent };